import { call, put, takeLeading } from 'redux-saga/effects';
import apiClient from 'communication/apiClient';
import * as actions from './actions';
import * as types from './types';

export function* loadNews() {
  try {
    const resp = yield call(apiClient.get, '/api/v1/manager/news-and-events');
    if (resp && resp.data) {
      yield put(actions.setLoadedNews(resp.data));
    } else {
      yield put(actions.failNewsLoad(resp));
    }
  } catch (error) {
    yield put(actions.failNewsLoad('error'));
  }
}

export default [takeLeading(types.LOAD_NEWS, loadNews)];
